// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"JobCardLogo_logoContainer__LvDGe","logoImage":"JobCardLogo_logoImage__Qwv5_","nullLogo":"JobCardLogo_nullLogo__erqh_"};